import { cn } from '@/lib/cn';

export type ButtonVariant = 'encre' | 'ligne' | 'ciel';

const BASE =
  'inline-flex min-h-11 cursor-pointer items-center justify-center gap-2 rounded-pill border-0 ' +
  'px-[22px] py-3.5 font-sans text-body-xs leading-none font-medium whitespace-nowrap no-underline ' +
  'transition-colors disabled:cursor-not-allowed disabled:opacity-60';

/**
 * Trois boutons (maquette) : encre sur clair, ligne en second, ciel sur
 * encre. Les survols jouent sur l'opacité, jamais sur une autre teinte
 * (charte § 06). Le libellé d'un bouton ciel est en encre (9.6:1).
 */
const VARIANTS: Record<ButtonVariant, string> = {
  encre: 'bg-encre text-blanc hover:bg-encre/85',
  ligne: 'bg-transparent text-encre shadow-[inset_0_0_0_1px_var(--color-line)] hover:bg-blanc',
  ciel: 'bg-ciel text-encre hover:bg-ciel/85',
};

export function buttonStyles(variant: ButtonVariant = 'encre', className?: string): string {
  return cn(BASE, VARIANTS[variant], className);
}
